export default "__VITE_ASSET__167745f7__"